import { customStyle } from 'styles/functions'

export const mvm = {
  logo_image_url: 'mvm.png',
  header_full_height: true,

  body_background_color: '#EBEBEB',

  token_url: 'mvm.png',
  token_width: 60,
  token_margin_top: 14,
  number_hidden: true,

  button_color: '#17A0AD',
  button_radius: 50,
  button_text_weight: 600,

  button_half_border_color: '#17A0AD',

  text_font: `'Raleway', sans-serif`,
  text_color: '#3A3A3C',
  title_font: `'Raleway', sans-serif`,
  title_weight: 800,
  subtitle_weight: 700,
}
export const mvm_festival = {
  ...mvm,
  body_background_color: '#404040',
  button_color: '#E09423',
  button_radius: 15,
  token_url: 'mvm_festival.png',
  logo_image_url: 'mvm_festival.png',
}
export const mvm_patrimoine = {
  ...mvm,
  body_background_color: '#404040',

  button_border_width: 3,
  button_color: '#62825B',
  button_radius: 15,

  token_width: 35,
  token_margin_left: 10,
  token_margin_top: 10,
  token_margin_right: 10,

  token_url: 'mvm_patrimoine.png',
  logo_image_url: 'mvm_patrimoine.png',
  footer_border_color: '#eee',
  footer_text_color: '#404040',
  legend_color: '#404040',
  font_color: '#404040',
  number_color: '#404040',
  text_color: '#404040',
  title_color: '#404040',
}